import React  from 'react';
import { Page, Toolbar, Tab, Link, Tabs } from 'framework7-react';
import HomeTab from "../pages/HomeTab";
import MenuTab from "../pages/MenuTab";
import BidsTab from "../pages/BidsTab";
import OrdersTab from "../pages/OrdersTab";
import ProfileTab from "../pages/ProfileTab";
import { useState , useEffect} from 'react';
// import OTPTab from "./pages/OtpVerification";

const TabMain = () => {
  // const [isBottom, setIsBottom] = useState(true);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1024);
  useEffect(()=>{
    setIsMobile(window.innerWidth <= 1024);
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 1024);

    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };

  },[])
  return (
  <Page className='bg-white'>
      <Toolbar tabbar noShadow bottom className={isMobile ? "navbar-menu":"navbar-menu-left appBottomMenu" }>
        <Link
          tabLink="#tab-1"
          text="HOME"
          tabLinkActive
          className="text-1"      
          iconIos="material:home"
          iconAurora="material:home"
          iconMd="material:home"          
        ></Link>
        <Link
          tabLink="#tab-2"
          text="MENU"      
          className="text-1" 
          iconIos="material:menu_book"
          iconAurora="material:menu_book"
          iconMd="material:menu_book"             
        ></Link>
        <Link
          tabLink="#tab-3"
          text="BIDS"      
          className="text-1"
          iconIos="material:date_range"
          iconAurora="material:date_range"
          iconMd="material:date_range"           
        ></Link>
        <Link
          tabLink="#tab-5"
          text="PROFILE"      
          className="text-1"
          iconIos="material:person_outline"
          iconAurora="material:person_outline"
          iconMd="material:person_outline"
        ></Link>
      </Toolbar>
      <Tabs>
        <Tab id="tab-1" tabActive>
          <HomeTab />          
        </Tab>
        <Tab id="tab-2">
          <MenuTab />
        </Tab>
        <Tab id="tab-3">
          <BidsTab />          
        </Tab>
        <Tab id="tab-4">
          <OrdersTab />
        </Tab>
        <Tab id="tab-5">
          <ProfileTab />
        </Tab>
      </Tabs>
    </Page>
  );
};

export default TabMain;